<div class="position-relative overflow-hidden h-100 d-flex">
    <div class="flex-grow-1 overflow-hidden px-sm-4 pt-4">
        <dx-data-grid
            id="gridContainer"
            class="grid theme-dependent"
            noDataText=""
            height="100%"
            [dataSource]="dataSource"
            [allowColumnResizing]="true"
            [allowColumnReordering]="true"
            [focusedRowEnabled]="true"
            [autoNavigateToFocusedRow]="false"
            [showBorders]="true"
            [remoteOperations]="true"
            [columnAutoWidth]="true"
            [wordWrapEnabled]="true"
            [stateStoring]="{ enabled: true, type: 'localStorage', storageKey: 'users-grid-state', savingTimeout: 0 }"
            [(focusedRowKey)]="userId"
            (onRowDblClick)="onRowDblClick($event)"
            (onExporting)="onExporting($event)"
            [customizeColumns]="customizeColumns"
            keyExpr="id"
            width="100%"
        >
            <dxo-scrolling [scrollByContent]="true"></dxo-scrolling>
            <dxo-paging [pageSize]="10"></dxo-paging>
            <dxo-pager
                [visible]="true"
                [displayMode]="'full'"
                [showPageSizeSelector]="true"
                [showInfo]="true"
                [showNavigationButtons]="true"
            >
            </dxo-pager>

            <dxo-load-panel [showPane]="false"></dxo-load-panel>
            <dxo-sorting mode="multiple"></dxo-sorting>
            <dxo-header-filter [visible]="true"></dxo-header-filter>
            <dxo-filter-row [visible]="true" [applyFilter]="'auto'"></dxo-filter-row>
            <dxo-column-chooser [enabled]="true"></dxo-column-chooser>
            <dxo-search-panel
                [visible]="true"
                placeholder="Search"
            ></dxo-search-panel>
            <dxo-export [enabled]="true" [formats]="['xlsx']"></dxo-export>
            <dxo-column-chooser height="340px" [enabled]="true" [mode]="'select'">
                <dxo-position my="right top" at="right bottom" of=".dx-datagrid-column-chooser-button"></dxo-position>
                <dxo-search [enabled]="true"></dxo-search>
                <dxo-selection [allowSelectAll]="true" [selectByClick]="true" [recursive]="true"></dxo-selection>
            </dxo-column-chooser>

            <dxo-toolbar>
                <dxi-item location="before">
                    <div class="grid-header">Users</div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    widget="dxButton"
                    [options]="{ text: 'Filters', icon: 'fa-sharp fa-thin fa-filter', onClick: toggleFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    showText="inMenu"
                    widget="dxButton"
                    [options]="{ text: 'Clear Filters', icon: 'fa-sharp fa-thin fa-filter-slash', onClick: clearFilters, stylingMode: 'text' }"
                ></dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="auto"
                    showText="inMenu"
                    widget="dxButton"
                    [options]="{
                    text: 'Reset',
                    icon: 'restore',
                    onClick: resetGrid,
                    stylingMode: 'text'
                }"
                ></dxi-item>
                <!-- Separator -->
                <dxi-item location="after" locateInMenu="auto">
                    <div class="separator"></div>
                </dxi-item>
                <dxi-item name="columnChooserButton" locateInMenu="auto"></dxi-item>
                <dxi-item name="exportButton"></dxi-item>
                <dxi-item
                    location="after"
                    locateInMenu="never"
                    [visible]="authService.checkPermission(PermissionType.UserList, AccessType.Edit)"
                >
                    <dx-button
                        text="New"
                        icon="plus"
                        type="default"
                        stylingMode="contained"
                        (onClick)="addUser()"
                    ></dx-button>
                </dxi-item>
            </dxo-toolbar>

            <dxi-column type="buttons" [width]="50" [showInColumnChooser]="false">
                <dxi-button hint="Impersonate" icon="login" [visible]="isImpersonateVisible" [onClick]="onImpersonateClick"></dxi-button>
            </dxi-column>

            <dxi-column [dataField]="'employee.name'" caption="Name" [minWidth]="200"></dxi-column>
            <dxi-column [dataField]="'employee.email'" caption="Email" [minWidth]="200"></dxi-column>
            <dxi-column [dataField]="gridFieldName('mainRole')" caption="Roles" [minWidth]="200"
                        [allowSorting]="false"
                        [filterOperations]="['=']"
                        [lookup]="{ dataSource: roleOptions, valueExpr: 'value', displayExpr: 'text' }"
                        [headerFilter]="{ dataSource: roleOptions, allowSelectAll: false }"
                        cellTemplate="roles"
            >
                <div *dxTemplate="let cellInfo of 'roles'">
                    @for (role of getCellData(cellInfo).roles; track role) {
                        <div class="badge bg-light text-dark mb-1">
                            {{ role }}
                        </div>
                    }
                </div>
            </dxi-column>
            <dxi-column [dataField]="gridFieldName('address')" caption="Address" [minWidth]="150"></dxi-column>
            <dxi-column [dataField]="gridFieldName('phone')" caption="Phone number" cellTemplate="phone" [minWidth]="150"></dxi-column>
            <dxi-column [dataField]="gridFieldName('status')" caption="Status" [minWidth]="150"
                        [allowSearch]="false"
                        [filterOperations]="['=']"
                        [lookup]="{ dataSource: statusOptions, valueExpr: 'value', displayExpr: 'text' }"
                        [headerFilter]="{ dataSource: statusOptions }"
                        cellTemplate="status"
            >
                <div *dxTemplate="let cellInfo of 'status'">
                    <span class="badge" [ngClass]="getStatusBadgeClass(getCellData(cellInfo).status)">
                        {{ cellInfo.displayValue }}
                    </span>
                </div>
            </dxi-column>

            <div *dxTemplate="let cellInfo of 'name'" class="name-template">
                <user-avatar-email
                    [email]="getCellData(cellInfo).employee.email"
                    [name]="getCellData(cellInfo).employee.name"
                    [avatarUrl]="getCellData(cellInfo).employee.avatarUrl"
                ></user-avatar-email>
            </div>

            <div *dxTemplate="let cellInfo of 'phone'">
                {{ getCellData(cellInfo).phone | formatPhone }}
            </div>
        </dx-data-grid>
    </div>
    <filter-panel
        [(isOpened)]="isFilterPanelOpened"
        (onSearch)="applyFilters()"
        (onClear)="clearFilters()"
        (pinnedChange)="onPinnedChange()"
    >
        <dx-form [formData]="filterModel">
            <dxi-item
                [dataField]="'employee.name'"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Name', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="'employee.email'"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Email', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="gridFieldName('mainRole')"
                editorType="dxSelectBox"
                [editorOptions]="{ items: roleOptions, valueExpr: 'value', displayExpr: 'text', placeholder: 'Role', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="gridFieldName('address')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Address', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="gridFieldName('phone')"
                editorType="dxTextBox"
                [editorOptions]="{ placeholder: 'Phone', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
            <dxi-item
                [dataField]="gridFieldName('status')"
                editorType="dxSelectBox"
                [editorOptions]="{ items: statusOptions, valueExpr: 'value', displayExpr: 'text', placeholder: 'Status', stylingMode: 'filled' }"
                [colSpan]="1"
            ></dxi-item>
        </dx-form>
    </filter-panel>
    <form-popup [(visible)]="isAddUserPopupOpened" (save)="onAddEmployeePopupSaveClick()" titleText="New User">
        <add-employee-form [showShiftField]="false"></add-employee-form>
    </form-popup>
</div>
